module.exports = __webpack_public_path__ + "img/CallEndOutlined.b47b4c0c.svg";